import { useCallback, useState } from 'react';

import type { StepErrors } from './private-event-validation';

/** Field-keyed errors for an inline form, cleared as each field is edited. */
export function useFieldErrors() {
  const [errors, setErrors] = useState<StepErrors>({});
  const fieldError = useCallback(
    (key: string): string | undefined => errors[key] || undefined,
    [errors],
  );
  const clear = useCallback((...keys: string[]) => {
    setErrors((prev) => {
      const next = { ...prev };
      for (const key of keys) delete next[key];
      return next;
    });
  }, []);
  return { errors, setErrors, fieldError, clear };
}
